<div class="idp-error-indicator" aria-live="assertive">
  <img
    class="idp-error-indicator_icon"
    src="/content/dam/delta-applications/sitewide/capability/flight-shop/images/alert.svg"
  />
  <a
    href="javascript:void(0)"
    class="idp-error-indicator_anchor"
    [tabIndex]="0"
    (click)="handleErrorMessageClick()"
  >
    {{ toContinueText }} {{ errorMsg }}
  </a>
</div>
